import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import Industries from './components/Industries';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <main>
        <HowItWorks />
        <Industries />
        {/* Additional sections can be added here like About, Contact, etc. */}
      </main>
      <Footer />
    </div>
  );
}

export default App;